var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDireita({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10423 7.83703L4.05672 11.6408C2.57881 12.7553 0.462891 11.6974 0.462891 9.84795V2.2484C0.462891 0.398992 2.57881 -0.658941 4.05672 0.455548L9.10423 4.25932C10.2995 5.15575 10.2995 6.94863 9.10423 7.84507V7.83703Z",
    fill: "#FF6600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDireita);
export default __webpack_public_path__ + "static/media/Direita.8d845dda27f715dcf48c9d67dee89d28.svg";
export { ForwardRef as ReactComponent };